import React from "react"

export const ModalSuccessNote = ({ text, className = "" }) => (
  <div className={`c-modal-note c-modal-note--success d-flex ${className}`}>
    <div>{text}</div>
  </div>
)
